import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyC3MHP4_5Dge49_QdACmYLub2I5T_dleow",
    authDomain: "dentocare-30a54.firebaseapp.com",
    projectId: "dentocare-30a54",
    storageBucket: "dentocare-30a54.firebasestorage.app",
    messagingSenderId: "492164751949",
    appId: "1:492164751949:web:c1ff50f69ec6bbc0ed3204",
    measurementId: "G-NVTZ0TR2GQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;
